import { useMainStore } from '@/stores/main'

import { useGtm } from '@gtm-support/vue-gtm'

export function useGtmTracking() {
  const gtm = useGtm()
  const mainStore = useMainStore()

  function trackGtmEvent(event: string, data?: Record<string, unknown>) {
    if (!gtm?.enabled()) return
    window.dataLayer?.push({
      event,
      ...mainStore.gtmCustomDimensionsMerged,
      ...data
    })
  }

  return { trackGtmEvent }
}
